import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage/index.js"; // Uses localStorage for web
import rootReducer from "../reducer/index.js";

const persistConfig = {
  key: "mallbuddy-admin",
  storage,
  whitelist: [
    "user",
  ],
};

const authListenerMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  
  // Listen for specific actions
  if (action.type === "user/logoutUser" || action.type === "user/setIsAuthenticated" ||
      (action.type === "user/setLoginUser" && !action.payload)) {
   
  }
  
  return result;
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
      immutableCheck: process.env.NODE_ENV === "development",
    }).concat(authListenerMiddleware),
  devTools: process.env.NODE_ENV !== "production",
});

export const persistor = persistStore(store);

export default store;